import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PointApiV2 } from '../../../lib/api/point/PointApiV2';
import { PointLogsFindResponseBodyDto } from '../../../types/api/point-logs';
import { POINT } from '../../../constants/queryKeys';
import { QueryOptions } from '../../../types/query/useQuery';
import { PointLogsFindRequestBodyDto } from '../../../types/point';

type UseFetchPointLogsQuery<SelectResultType> = {
  params: PointLogsFindRequestBodyDto;
  options?: QueryOptions<PointLogsFindResponseBodyDto, unknown, SelectResultType>;
};

export const useFetchPointLogsQuery = <SelectResultType>(
  payload: UseFetchPointLogsQuery<SelectResultType>,
): UseQueryResult<SelectResultType, unknown> => {
  const { params, options } = payload;
  return useQuery<PointLogsFindResponseBodyDto, unknown, SelectResultType>(
    [...POINT.LOGS, params],
    () => PointApiV2.fetchPointLogs(params),
    {
      ...options,
      enabled: !!params.userId,
    },
  );
};
